module.exports = __webpack_public_path__ + "img/php.5b942b15.gif";